// Rotating status messages shown in the "Auto-fixing your package"
// overlay while `fixZip` runs. The fixer itself is fast (no I/O —
// everything happens in the browser) but the rebuild can still take a
// noticeable beat on a hundreds-of-MB archive, and an empty progress
// bar feels broken. The quips give creators something to read.
//
// Add new lines to this array — order doesn't matter, the renderer
// picks at random and rotates every ~1.5s.

export const FIX_QUIPS: readonly string[] = [
  "Finding the grass blocks...",
  "Controlling the pigmen...",
  "Convincing the creepers to keep their distance...",
  "Rebooting the redstone...",
  "Polishing the diamonds...",
  "Asking the villagers nicely...",
  "Smelting cobblestone...",
  "Brushing the parrots...",
  "Untangling the spider webs...",
  "Petting the wolves...",
  "Calibrating the compasses...",
  "Defragmenting the End portal...",
  "Tuning the note blocks...",
  "Counting stacks of 64...",
  "Re-feathering the chickens...",
  "Reorganising the chest sort...",
  "Breeding the cows responsibly...",
  "Reminding the ghasts to behave...",
  "Coaxing the axolotls back into water...",
  "Restocking the librarian's books...",
  "Brushing the suspicious sand...",
  "Sharpening the netherite...",
  "Whispering to the warden...",
  "Untying the lead from the boat...",
  "Resetting the spawn point...",
  "Negotiating with the piglins...",
  "Mending the elytra...",
  "Updating the daylight detector...",
  "Tidying up the bookshelves...",
  "Bartering with the wandering trader...",
  "Quieting down the bee swarm...",
  "Re-laminating the prismarine...",
  "Trimming the bamboo grove...",
  "Filing down a fresh stack of stairs...",
  "Reseating the chiseled bookshelf...",
  "Restocking the brewing stand...",
  "Re-aligning the lodestones...",
  "Stapling the saddle on the strider...",
  "Re-glazing the terracotta...",
  "Walking the leashed llama...",
];
